// System
import { useSnackbar } from 'notistack';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Stack, Typography, Box, IconButton } from '@mui/material';

// Styles
import Styles from './SetupCampaignHeader.module.scss';
import { useCampaignDrawer } from '@Modal/hooks/campaigns/useCampaignDrawer';

export const SetupCampaignHeader: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { selectedCampaignData } = useCampaignDrawer();

  const handleCopy = () => {
    if (selectedCampaignData._id) {
      navigator.clipboard.writeText(selectedCampaignData._id).then(() => {
        enqueueSnackbar('Campaign ID copied', {
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
        });
      });
    }
  };

  return (
    <Stack className={Styles.SetupCampaignHeader}>
      <Box className={Styles.QrCode}>
        <Typography variant="h6">{selectedCampaignData._id}</Typography>
      </Box>
      <IconButton onClick={handleCopy}>
        <ContentCopyIcon />
      </IconButton>
    </Stack>
  );
};
